import RegisterHeaderTab from "./RegisterHeaderTab";
export default RegisterHeaderTab;
